import React from "react";
import { connect } from "formik";
import { get } from "lodash";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import LenderInformation from "./lenderInformation";
import { Divider, StyledGridContainer, StyledFormikInputText, StyledFormikInputTypeAhead } from "./quoteDetails.styles";

const LenderPassedTabContent = ({ formik, handleOpenRequestContactModal }) => {
  const { values } = formik;
  const loanTypes = values && get(values, "ancillary.loanTypes", []);
  const passReasons = values && get(values, "ancillary.passReasons", []);

  return (
    <Grid container>
      <LenderInformation
        formik={formik}
        onOpenRequestContactModal={handleOpenRequestContactModal}
      />
      <Divider />
      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="details.loanTypeId"
          label="Loan Type"
          options={loanTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <Divider />
      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="passReasonId"
          name="details.passReasonId"
          label="Reason for passing"
          options={passReasons}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={"details.passComment"}
          label={"Comment"}
          variant={"filled"}
          multiLine
        />
      </StyledGridContainer>

    </Grid>
  );
};

export default compose(connect)(LenderPassedTabContent);
